<template>
  <div class="dailylist_box border_box">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finished_text"
      @load="getReportList"
    >
      <a class="daily_item border_box" v-for="(item,i) of list" :key="i" @click="openReport(item)">
        <div class="daily_log border_box flex_v_center">
          <div class="content_box">
            <div class="flex_verticle">
              <!-- <span class="log_icon wangcan" v-if="item.reportType == 0"></span>
              <span class="log_icon xinguan" v-if="item.reportType == 1"></span>
              <span class="daily_txt">{{item.name}}</span> -->
              <!-- 1- 新冠 0 - 网参 2-专家视角 -->
              <div class="log_icon xinguan" v-if="item.reportType == 1"></div> 
              <div class="log_icon event" v-else-if="item.reportType == 2"></div>
               <div class="log_icon wangcan" v-else></div>
              <!-- status  0 免费 1 收费 2 已购 -->
              <div class="info_box">
                <span class="daily_txt">{{item.name}}</span>
                <span class="status_txt jingpin" v-if="item.status === 1">精品</span>
                <span class="status_txt purchased" v-else-if="item.status === 2">已购</span>
              </div>
            </div>
          </div>
          <span class="arrow_icon"></span>
        </div>
      </a>
    </van-list>
    <div class="nodata_box border_box" v-show="nodate">无数据</div>
  </div>
</template>
<script>
  import {getReportList} from '@/api/judgment'
  import { List} from 'vant'
  export default {
    name: 'epidemicReportList',
    data() {
      return {
        params: {
          pageSize: "15",         // 每页条数
          pageNum: "0",           //页码
        },
        finished_text:"",
        nodate:false,
        list: [],
        loading: false,
        finished: false,
        load: true,              //用于判断是否加载中
      }
    },
    components: {
      "van-list": List
    },  
    methods: {
      openReport(item) {        
        this.$router.push({path: 'epidemicReportDetail', query: {
          url : item.fileUrl,
          title:item.name, 
          status: item.status,
          id: item.id,
          openid: this.$store.state.userInfo.openid
        }});
      },
      //加载数据
      onLoad(){
        
      },
      //获取列表
      getReportList() {
        // 接口响应前，先显示加载中
        this.loading = true;
        this.params.pageNum = parseInt(this.params.pageNum) + 1
        getReportList(this.params).then(res => {
          let total = res.data.result.total
          if (res.data.result.data && res.data.result.data.length > 0) {
            this.list = [...this.list, ...res.data.result.data]
            if(this.list.length == 0){
              this.nodate = true;
            }
            if(this.list.length >= total) {
              this.finished = true;
            }
            if (res.data.result.data.length <15)  {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
            if(this.list.length >0 && this.finished){
              this.finished_text = "没有更多了";
              
            }else{
              
              this.finished_text = "";
            }
            // 加载状态结束
            this.loading = false;
          }).catch(err => {
            this.loading = false;
            this.finished = true;
            console.log(err);
          });
      }
    },
    mounted() {
      // this.onLoad();
      // wxShare('舆情研判日报','快来看看我分享的网站:舆情研判日报');
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("./list.css");
</style>
